import { APP_BASE_HREF } from '@angular/common';
import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
export interface FileHandle {
  file: File;
  url: SafeUrl;
}
@Component({
  selector: 'image-uploader',
  template: `
    <div class="dd-box">
      <span class="item">Drag and Drop</span><br />
      <label
        class="uploader"
        ondragover="return false;"
        [class.loaded]="loaded"
        [style.outlineColor]="dragging ? activeColor : baseColor"
        (dragenter)="handleDragEnter()"
        (dragleave)="handleDragLeave()"
        (drop)="handleDrop($event)"
      >
        <!-- class="icon icon-upload bi bi-upload fs-1" -->
        <img
          [hidden]="imageLoaded"
          [src]="baseHref + '/assets/images/icon-download.svg'"
          [style.color]="
            dragging
              ? imageSrc.length > 0
                ? overlayColor
                : activeColor
              : imageSrc.length > 0
                ? overlayColor
                : baseColor
          "
        />
        <br />

        <img alt="" [src]="imageSrc" (load)="handleImageLoad()" [class.loaded]="imageLoaded" />
      </label>
      <span class="item">File Here</span>
    </div>
    <input (change)="handleInputChange($event)" type="file" id="actual-btn" hidden />

    <!-- our custom upload button -->
    <span class="item">Or</span><br />
    <div class="choose-file-box mt-1">
      <label for="actual-btn" class="outline-btn info-lbl">Choose File</label>

      <!-- name of file chosen -->
      <span id="file-chosen" class="item ps-2">No file chosen</span>
    </div>
  `,
  styleUrls: ['image-uploader.component.scss'],
  inputs: ['activeColor', 'baseColor', 'overlayColor'],
})
export class ImageUploaderComponent {
  @Output() files: EventEmitter<any> = new EventEmitter();
  constructor(
    private sanitizer: DomSanitizer,
    @Inject(APP_BASE_HREF) public baseHref: string
  ) {}
  activeColor: string = 'green';
  baseColor: string = '#ccc';
  overlayColor: string = 'rgba(255,255,255,0.5)';

  dragging: boolean = false;
  loaded: boolean = false;
  imageLoaded: boolean = false;
  imageSrc: string = '';

  handleDragEnter() {
    this.dragging = true;
  }

  handleDragLeave() {
    this.dragging = false;
  }

  handleDrop(e) {
    e.preventDefault();
    this.dragging = false;
    this.handleInputChange(e);
  }

  handleImageLoad() {
    this.imageLoaded = true;
  }

  handleInputChange(e) {
    const file = e.dataTransfer ? e.dataTransfer.files[0] : e.target.files[0];
    console.log(file.size + 'Imagesize');
    const pattern = /image-*/;
    const reader = new FileReader();

    this.loaded = false;

    if (!file.type.match(pattern)) {
      alert('Invalid image format');
      return;
    }
    if (file.size >= 10000000) {
      alert('File size is more than 10 MB');
      return;
    }

    reader.onload = this._handleReaderLoaded.bind(this);
    //alert( 'here'+file);
    const actualBtn = document.getElementById('actual-btn');

    const fileChosen = document.getElementById('file-chosen');

    actualBtn.addEventListener('change', function () {
      if (fileChosen) {
        fileChosen.textContent = file.name;   
      }
    });
    // SECURITY: Use textContent instead of innerHTML to prevent XSS from malicious filenames
    document.getElementById('file-chosen').textContent = file.name;
    this.files.emit(file);
    reader.readAsDataURL(file);
  }

  _handleReaderLoaded(e) {
    const reader = e.target;
    this.imageSrc = reader.result;
    this.loaded = true;
    const files: any = [];
  }
}
